import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import WithAuth from 'src/components/auth/WithAuth';

const AddPostDropdown = ({ openModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <WithAuth>
      <div className="my-4">
        <Button
          id="create-post-dropdown"
          variant="contained"
          onClick={handleClick}
          aria-controls={open ? 'menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          Create Post
        </Button>
        <Menu
          id="menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ 'aria-labelledby': 'create-post-dropdown' }}
        >
          <MenuItem
            id="message"
            onClick={() => {
              openModal(true);
              handleClose();
            }}
          >
            Message
          </MenuItem>
        </Menu>
      </div>
    </WithAuth>
  );
};

export default AddPostDropdown;
